import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3bbc93a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 mt-xl-7 mt-lg-1 mb-10 d-none d-lg-block filt position-sticky" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 text-start" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-5 fw-bold mb-2" }, "Filtros")
], -1))
const _hoisted_4 = { class: "col-lg-6 text-end pointer" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_7 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_8 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Año", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "accordion-body border-0 p-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "fs-sm fw-normal" }
const _hoisted_15 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_16 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Marcas y modelos", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "accordion-body p-4 border-0" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "accordion-item border-0" }
const _hoisted_24 = ["id"]
const _hoisted_25 = ["onClick", "data-bs-target", "aria-controls"]
const _hoisted_26 = { class: "fs-sm fw-normal" }
const _hoisted_27 = ["id", "aria-labelledby"]
const _hoisted_28 = { class: "accordion-body border-0 p-4" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "fs-sm fw-normal" }
const _hoisted_32 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_33 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_3"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Precio", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "accordion-body border-0 p-4" }
const _hoisted_37 = { class: "col-11" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-6" }
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-5 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_4",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_4"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Tipo de carrocería")
  ])
], -1))
const _hoisted_43 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_4"
}
const _hoisted_44 = { class: "accordion-body border-0 p-4" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = ["src", "alt"]
const _hoisted_49 = { class: "fs-sm fw-normal" }
const _hoisted_50 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_5"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-5 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_5",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_5"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Transmisión")
  ])
], -1))
const _hoisted_52 = {
  id: "kt_accordion_1_body_5",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_5"
}
const _hoisted_53 = { class: "accordion-body border-0 p-4" }
const _hoisted_54 = { class: "col-12 my-2 mx-auto" }
const _hoisted_55 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_56 = { class: "fs-sm fw-normal" }
const _hoisted_57 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_6"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-5 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_6",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_6"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Tipo de combustible")
  ])
], -1))
const _hoisted_59 = {
  id: "kt_accordion_1_body_6",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_6"
}
const _hoisted_60 = { class: "accordion-body border-0 p-4" }
const _hoisted_61 = { class: "col-12 my-2 mx-auto px-5" }
const _hoisted_62 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_63 = { class: "fs-sm fw-normal" }
const _hoisted_64 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_65 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_7"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Estado/Ciudad", -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "accordion-body border-0 p-4" }
const _hoisted_69 = { class: "col-12 my-2 mx-auto px-5" }
const _hoisted_70 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_72 = { class: "fs-sm fw-normal" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_74 = { class: "fs-sm fw-normal" }
const _hoisted_75 = { class: "d-flex justify-content-between d-lg-none align-items-center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-40px h-40px bg-secondary d-flex justify-content-center align-items-center rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-arrow-left text-white fs-2x" })
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0 ms-3 fs-2 fw-bold" }, "Resultados", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_filters",
  class: "w-50px h-50px bg-primary d-flex justify-content-center align-items-center rounded-circle"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-filter text-white fs-5" })
], -1))
const _hoisted_79 = {
  class: "modal fade",
  ref: "newCardModalRef",
  id: "modal_filters",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_80 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen" }
const _hoisted_81 = { class: "modal-content" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header py-3 px-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fs-5 fw-bold" }, "Filtros"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-sm btn-icon btn-active-color-primary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" })
    ])
  ])
], -1))
const _hoisted_83 = { class: "modal-body px-5 py-3" }
const _hoisted_84 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_85 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_86 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Año", -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "accordion-body border-0 p-4" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "fs-sm fw-normal" }
const _hoisted_93 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_94 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_2"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Marcas y modelos", -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = { class: "accordion-body border-0 p-4" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_99 = { class: "row" }
const _hoisted_100 = ["id"]
const _hoisted_101 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_102 = ["id"]
const _hoisted_103 = ["onClick", "data-bs-target", "aria-controls"]
const _hoisted_104 = { class: "fs-sm fw-normal" }
const _hoisted_105 = ["id", "aria-labelledby"]
const _hoisted_106 = { class: "accordion-body border-0 p-4" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = { class: "fs-sm fw-normal" }
const _hoisted_110 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_111 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_3"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Precio", -1))
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "accordion-body border-0 p-4" }
const _hoisted_115 = { class: "col-11" }
const _hoisted_116 = { class: "row" }
const _hoisted_117 = { class: "col-6" }
const _hoisted_118 = { class: "col-6" }
const _hoisted_119 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-4 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_4",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_4"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Tipo de carrocería")
  ])
], -1))
const _hoisted_121 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_4"
}
const _hoisted_122 = { class: "accordion-body border-0 p-4" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_124 = ["onClick"]
const _hoisted_125 = ["src", "alt"]
const _hoisted_126 = { class: "fs-sm fw-normal" }
const _hoisted_127 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_5"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-4 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_5",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_5"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Transmisión")
  ])
], -1))
const _hoisted_129 = {
  id: "kt_accordion_1_body_5",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_5"
}
const _hoisted_130 = { class: "accordion-body border-0 p-4" }
const _hoisted_131 = { class: "col-12 my-2 mx-auto" }
const _hoisted_132 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_133 = { class: "fs-sm fw-normal" }
const _hoisted_134 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_6"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button px-3 py-4 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_6",
    "aria-expanded": "false",
    "aria-controls": "kt_accordion_1_body_6"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Tipo de combustible")
  ])
], -1))
const _hoisted_136 = {
  id: "kt_accordion_1_body_6",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_6"
}
const _hoisted_137 = { class: "accordion-body border-0 p-4" }
const _hoisted_138 = { class: "col-12 my-2 mx-auto px-5" }
const _hoisted_139 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_140 = { class: "fs-sm fw-normal" }
const _hoisted_141 = {
  class: "accordion-item",
  style: {"border":"none"}
}
const _hoisted_142 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_7"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Estado/Ciudad", -1))
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = { class: "accordion-body border-0" }
const _hoisted_146 = { class: "col-12 my-2 mx-auto px-5" }
const _hoisted_147 = { class: "mb-2 flex items-center fs-sm" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "el-input__icon me-5 p-1",
  src: "media/icons/iconsax/search-normal.svg"
}, null, -1))
const _hoisted_149 = { class: "fs-sm fw-normal" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_151 = { class: "fs-sm fw-normal" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  "data-bs-dismiss": "modal",
  class: "btn btn-primary w-100 mt-6"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Aplicar filtros")
], -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm fw-normal" }, "Limpiar filtros", -1))
const _hoisted_154 = [
  _hoisted_153
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clearFilters && $setup.clearFilters(...args))),
            class: "fs-sm mb-2 me-2"
          }, "Limpiar filtros")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button px-3 py-5", $setup.paramsQuery.year == '' && 'collapsed']),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#kt_accordion_1_body_1",
                  "aria-expanded": "true",
                  "aria-controls": "kt_accordion_1_body_1"
                }, _hoisted_10, 2)
              ]),
              _createElementVNode("div", {
                id: "kt_accordion_1_body_1",
                class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.year != '' && 'show']),
                "aria-labelledby": "kt_accordion_1_header_1"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.years, (year) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-md-2 col-lg-3 text-center",
                        key: year
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => ($setup.applyFilter('year', year, 'push')),
                          class: _normalizeClass([$setup.paramsQuery.year.includes(year) && 'is-active', "btn btn-filters-years px-4 py-1"])
                        }, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(year), 1)
                        ], 10, _hoisted_13)
                      ]))
                    }), 128))
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h2", _hoisted_16, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button px-3 py-5", $setup.paramsQuery.brand == '' && $setup.paramsQuery.model == '' && 'collapsed']),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#kt_accordion_1_body_2",
                  "aria-expanded": "false",
                  "aria-controls": "kt_accordion_1_body_2"
                }, _hoisted_18, 2)
              ]),
              _createElementVNode("div", {
                id: "kt_accordion_1_body_2",
                class: _normalizeClass(["accordion-collapse collapse", ($setup.paramsQuery.brand != '' || $setup.paramsQuery.model != '') && 'show']),
                "aria-labelledby": "kt_accordion_1_header_2"
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_input, {
                    modelValue: $setup.searchBrand,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchBrand) = $event)),
                    class: "w-100 mb-1",
                    placeholder: "Buscar marca"
                  }, {
                    suffix: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedBrands, (brand) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12",
                        key: brand.id
                      }, [
                        _createElementVNode("div", {
                          class: "accordion",
                          id: 'kt_accordion_' + brand.brand
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("h2", {
                              class: "accordion-header",
                              id: 'kt_accordion_header' + brand.brand
                            }, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["brand-btn accordion-button btn-filters px-3 py-3 border-0", 
                              $setup.paramsQuery.brand.includes(brand.brand) && 'is-active'
                            ]),
                                onClick: ($event: any) => ($setup.applyFilter('brand', brand.brand, 'push-child')),
                                type: "button",
                                "data-bs-toggle": "collapse",
                                "data-bs-target": '#kt_accordion_1_body_1' + brand.brand,
                                "aria-expanded": "true",
                                "aria-controls": '#kt_accordion_1_body_1' + brand.brand
                              }, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(brand.brand), 1)
                              ], 10, _hoisted_25)
                            ], 8, _hoisted_24),
                            _createElementVNode("div", {
                              id: 'kt_accordion_1_body_1' + brand.brand,
                              class: _normalizeClass(["accordion-collapse", 
                            $setup.paramsQuery.brand.includes(brand.brand) ? 'show' : 'collapse'
                          ]),
                              "aria-labelledby": 'kt_accordion_header' + brand.brand
                            }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brand.models, (model) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "label-inline",
                                      key: 'm' + model.id
                                    }, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => ($setup.applyFilter('model', model.model, 'push')),
                                        class: _normalizeClass(["btn btn-filters-years py-1",  $setup.paramsQuery.model.includes(model.model) && 'is-active'])
                                      }, [
                                        _createElementVNode("span", _hoisted_31, _toDisplayString(model.model), 1)
                                      ], 10, _hoisted_30)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ], 10, _hoisted_27)
                          ])
                        ], 8, _hoisted_22)
                      ]))
                    }), 128))
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h2", _hoisted_33, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button px-3 py-5", $setup.paramsQuery.price == '' && 'collapsed']),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#kt_accordion_1_body_3",
                  "aria-expanded": "false",
                  "aria-controls": "kt_accordion_1_body_3"
                }, _hoisted_35, 2)
              ]),
              _createElementVNode("div", {
                id: "kt_accordion_1_body_3",
                class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.price != '' && 'show']),
                "aria-labelledby": "kt_accordion_1_header_3"
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.priceFrom,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.priceFrom) = $event)),
                          onChange: $setup.changePrice,
                          class: "rounded fs-sm",
                          formatter: 
                          (value) => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        ,
                          parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                          type: "text",
                          min: "0",
                          placeholder: "Precio mínimo"
                        }, null, 8, ["modelValue", "onChange", "formatter", "parser"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          min: "0",
                          modelValue: $setup.priceTo,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.priceTo) = $event)),
                          onChange: $setup.changePrice,
                          class: "rounded fs-sm",
                          formatter: 
                          (value) => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        ,
                          parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                          placeholder: "Precio maxímo"
                        }, null, 8, ["modelValue", "onChange", "formatter", "parser"])
                      ])
                    ]),
                    _createVNode(_component_el_slider, {
                      modelValue: $setup.priceValue,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.priceValue) = $event)),
                      class: "text-success my-2 filters",
                      "format-tooltip": $setup.formatTooltip,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.applyFilter('price', $setup.priceValue.toString(), 'range'))),
                      range: "",
                      max: 1000000
                    }, null, 8, ["modelValue", "format-tooltip"])
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_el_input, {
                    modelValue: $setup.searchType,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.searchType) = $event)),
                    class: "w-100 fs-sm fws-normal",
                    placeholder: "Buscar carroceria"
                  }, {
                    suffix: _withCtx(() => [
                      _hoisted_45
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedTypes, (tipo) => {
                    return (_openBlock(), _createElementBlock("div", { key: tipo }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => ($setup.applyFilter('type', tipo.type, 'replace')),
                        class: _normalizeClass([$setup.paramsQuery.type.includes(tipo.type) && 'is-active', "btn btn-filters me-3 w-100 my-2 py-2 px-3 text-start"])
                      }, [
                        (tipo.id != 10)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "me-3",
                              src: '/media/images/carrocerias/' + tipo.type.replace(/\s+/g, '') + '.svg',
                              alt: tipo.type
                            }, null, 8, _hoisted_47))
                          : _createCommentVNode("", true),
                        (tipo.id == 10)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: "me-3",
                              src: '/media/images/carrocerias/Crossover.svg',
                              alt: tipo.type
                            }, null, 8, _hoisted_48))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(tipo.type), 1)
                      ], 10, _hoisted_46)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: $setup.transmission,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.transmission) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.applyFilter('transmission', $event, 'replace'))),
                        class: "ml-4"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transmissions, (trans, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              class: "col-12",
                              key: index,
                              label: trans.type,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_56, _toDisplayString(trans.type), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: $setup.fuelModel,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.fuelModel) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.applyFilter('fuel', $event, 'replace'))),
                        class: "ml-4"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fuel, (fuel, index) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              class: "col-12",
                              key: index,
                              label: fuel.fuel,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_63, _toDisplayString(fuel.fuel), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("h2", _hoisted_65, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button px-3 py-5", $setup.paramsQuery.state == '' && 'collapsed']),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#kt_accordion_1_body_7",
                  "aria-expanded": "false",
                  "aria-controls": "kt_accordion_1_body_7"
                }, _hoisted_67, 2)
              ]),
              _createElementVNode("div", {
                id: "kt_accordion_1_body_7",
                class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.state != '' && 'show']),
                "aria-labelledby": "kt_accordion_1_header_7"
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: $setup.locationsModel,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.locationsModel) = $event)),
                        onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.applyFilter('state', $event, 'push'))),
                        class: "ml-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: $setup.searchState,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.searchState) = $event)),
                            class: "w-100 mb-5",
                            placeholder: "Buscar"
                          }, {
                            suffix: _withCtx(() => [
                              _hoisted_71
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedStates, (location, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-12",
                              key: index
                            }, [
                              _createVNode(_component_el_checkbox, {
                                class: "col-12",
                                label: location.state,
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_72, _toDisplayString(location.state), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _hoisted_73,
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: $setup.cityModel,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.cityModel) = $event)),
                                onChange: _cache[13] || (_cache[13] = ($event: any) => ($setup.applyFilter('city', $event, 'push'))),
                                class: "ms-6"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location.cities, (city) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                                      class: "col-12",
                                      key: Object.values(city)[0],
                                      size: "large",
                                      label: Object.values(city)[0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_74, _toDisplayString(Object.values(city)[0]), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createVNode(_component_router_link, {
        to: "/home",
        replace: "",
        class: "d-flex align-items-center"
      }, {
        default: _withCtx(() => [
          _hoisted_76,
          _hoisted_77
        ]),
        _: 1
      }),
      _hoisted_78
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("h2", _hoisted_86, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-3 py-4", $setup.paramsQuery.year == '' && 'collapsed']),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#kt_accordion_1_body_1",
                    "aria-expanded": "true",
                    "aria-controls": "kt_accordion_1_body_1"
                  }, _hoisted_88, 2)
                ]),
                _createElementVNode("div", {
                  id: "kt_accordion_1_body_1",
                  class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.year != '' && 'show']),
                  "aria-labelledby": "kt_accordion_1_header_1"
                }, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.years, (year) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-xl-3 col-md-2 col-4 col-lg-3",
                          key: year
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => ($setup.applyFilter('year', year, 'push')),
                            class: _normalizeClass([$setup.paramsQuery.year.includes(year) && 'is-active', "btn btn-filters-years px-3 py-1"])
                          }, [
                            _createElementVNode("span", _hoisted_92, _toDisplayString(year), 1)
                          ], 10, _hoisted_91)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("h2", _hoisted_94, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-3 py-4", 
                    $setup.paramsQuery.brand == '' && $setup.paramsQuery.model == '' && 'collapsed'
                  ]),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#kt_accordion_1_body_2",
                    "aria-expanded": "false",
                    "aria-controls": "kt_accordion_1_body_2"
                  }, _hoisted_96, 2)
                ]),
                _createElementVNode("div", {
                  id: "kt_accordion_1_body_2",
                  class: _normalizeClass(["accordion-collapse collapse", ($setup.paramsQuery.brand != '' || $setup.paramsQuery.model != '') && 'show']),
                  "aria-labelledby": "kt_accordion_1_header_2"
                }, [
                  _createElementVNode("div", _hoisted_97, [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.searchBrand,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.searchBrand) = $event)),
                      class: "w-100 mb-5 fs-sm",
                      placeholder: "Buscar marca"
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_98
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_99, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedBrands, (brand) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12",
                          key: brand.id
                        }, [
                          _createElementVNode("div", {
                            class: "accordion",
                            id: 'kt_accordion_' + brand.brand
                          }, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("h2", {
                                class: "accordion-header",
                                id: 'kt_accordion_header' + brand.brand
                              }, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["brand-btn accordion-button btn-filters fs-4 fw-bold p-2 border-0", 
                                $setup.paramsQuery.brand.includes(brand.brand) && 'is-active'
                              ]),
                                  onClick: ($event: any) => ($setup.applyFilter('brand', brand.brand, 'push-child')),
                                  type: "button",
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": '#kt_accordion_1_body_1' + brand.brand,
                                  "aria-expanded": "true",
                                  "aria-controls": '#kt_accordion_1_body_1' + brand.brand
                                }, [
                                  _createElementVNode("span", _hoisted_104, _toDisplayString(brand.brand), 1)
                                ], 10, _hoisted_103)
                              ], 8, _hoisted_102),
                              _createElementVNode("div", {
                                id: 'kt_accordion_1_body_1' + brand.brand,
                                class: _normalizeClass(["accordion-collapse", 
                              $setup.paramsQuery.brand.includes(brand.brand)
                                ? 'show'
                                : 'collapse'
                            ]),
                                "aria-labelledby": 'kt_accordion_header' + brand.brand
                              }, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brand.models, (model) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "col-3 text-center",
                                        key: 'm' + model.id
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => ($setup.applyFilter('model', model.model, 'push')),
                                          class: _normalizeClass(["btn btn-filters-years py-1 px-2", 
                                      $setup.paramsQuery.model.includes(model.model) &&
                                      'is-active'
                                    ])
                                        }, [
                                          _createElementVNode("span", _hoisted_109, _toDisplayString(model.model), 1)
                                        ], 10, _hoisted_108)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ], 10, _hoisted_105)
                            ])
                          ], 8, _hoisted_100)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("h2", _hoisted_111, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-3 py-4", $setup.paramsQuery.price == '' && 'collapsed']),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#kt_accordion_1_body_3",
                    "aria-expanded": "false",
                    "aria-controls": "kt_accordion_1_body_3"
                  }, _hoisted_113, 2)
                ]),
                _createElementVNode("div", {
                  id: "kt_accordion_1_body_3",
                  class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.price != '' && 'show']),
                  "aria-labelledby": "kt_accordion_1_header_3"
                }, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createVNode(_component_el_input, {
                            modelValue: $setup.priceFrom,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.priceFrom) = $event)),
                            onChange: $setup.changePrice,
                            class: "rounded fs-sm",
                            formatter: 
                            (value) => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          ,
                            parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                            type: "text",
                            min: "0",
                            placeholder: "$10,000"
                          }, null, 8, ["modelValue", "onChange", "formatter", "parser"])
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            min: "0",
                            modelValue: $setup.priceTo,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.priceTo) = $event)),
                            onChange: $setup.changePrice,
                            class: "rounded fs-sm",
                            formatter: 
                            (value) => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          ,
                            parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
                            placeholder: "$500,000"
                          }, null, 8, ["modelValue", "onChange", "formatter", "parser"])
                        ])
                      ]),
                      _createVNode(_component_el_slider, {
                        modelValue: $setup.priceValue,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.priceValue) = $event)),
                        class: "text-success my-2 filters",
                        "format-tooltip": $setup.formatTooltip,
                        onChange: _cache[20] || (_cache[20] = ($event: any) => ($setup.applyFilter('price', $setup.priceValue.toString(), 'range'))),
                        range: "",
                        max: 1000000
                      }, null, 8, ["modelValue", "format-tooltip"])
                    ])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_119, [
                _hoisted_120,
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.searchType,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.searchType) = $event)),
                      class: "w-100 fs-sm",
                      placeholder: "Buscar carroceria"
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_123
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedTypes, (tipo) => {
                      return (_openBlock(), _createElementBlock("div", { key: tipo }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => ($setup.applyFilter('type', tipo.type, 'replace')),
                          class: _normalizeClass([$setup.paramsQuery.type.includes(tipo.type) && 'is-active', "btn btn-filters me-3 w-100 my-2 py-2 px-3 text-start"])
                        }, [
                          _createElementVNode("img", {
                            class: "me-3",
                            src: '/media/images/carrocerias/' + tipo.type + '.png',
                            alt: tipo.type
                          }, null, 8, _hoisted_125),
                          _createElementVNode("span", _hoisted_126, _toDisplayString(tipo.type), 1)
                        ], 10, _hoisted_124)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: $setup.transmission,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.transmission) = $event)),
                          onChange: _cache[23] || (_cache[23] = ($event: any) => ($setup.applyFilter('transmission', $event, 'replace'))),
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transmissions, (trans, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                class: "col-12",
                                key: index,
                                label: trans.type,
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_133, _toDisplayString(trans.type), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: $setup.fuelModel,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.fuelModel) = $event)),
                          onChange: _cache[25] || (_cache[25] = ($event: any) => ($setup.applyFilter('fuel', $event, 'replace'))),
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fuel, (fuel, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                class: "col-12",
                                key: index,
                                label: fuel.fuel,
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_140, _toDisplayString(fuel.fuel), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("h2", _hoisted_142, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-3 py-4", $setup.paramsQuery.state == '' && 'collapsed']),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#kt_accordion_1_body_7",
                    "aria-expanded": "false",
                    "aria-controls": "kt_accordion_1_body_7"
                  }, _hoisted_144, 2)
                ]),
                _createElementVNode("div", {
                  id: "kt_accordion_1_body_7",
                  class: _normalizeClass(["accordion-collapse collapse", $setup.paramsQuery.state != '' && 'show']),
                  "aria-labelledby": "kt_accordion_1_header_7"
                }, [
                  _createElementVNode("div", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: $setup.locationsModel,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.locationsModel) = $event)),
                          onChange: _cache[30] || (_cache[30] = ($event: any) => ($setup.applyFilter('state', $event, 'push'))),
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.searchState,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.searchState) = $event)),
                              class: "w-100 mb-5",
                              placeholder: "Buscar"
                            }, {
                              suffix: _withCtx(() => [
                                _hoisted_148
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedStates, (location, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-12",
                                key: index
                              }, [
                                _createVNode(_component_el_checkbox, {
                                  class: "col-12",
                                  label: location.state,
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_149, _toDisplayString(location.state), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]),
                                _hoisted_150,
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: $setup.cityModel,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.cityModel) = $event)),
                                  onChange: _cache[28] || (_cache[28] = ($event: any) => ($setup.applyFilter('city', $event, 'push'))),
                                  class: "ms-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox, {
                                      class: "col-12",
                                      size: "large",
                                      label: location.city
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_151, _toDisplayString(location.city), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue"])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ], 2)
              ])
            ]),
            _hoisted_152,
            _createElementVNode("button", {
              onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => ($setup.clearFilters && $setup.clearFilters(...args))),
              "data-bs-dismiss": "modal",
              class: "btn btn-secondary fs-base fw-normal w-100 mt-6"
            }, _hoisted_154)
          ])
        ])
      ])
    ], 512)
  ], 64))
}